import { RootState } from '@Store/index';
import { createSelector } from '@reduxjs/toolkit';

const fileUpload = (state: RootState) => state.common.fileUpload;

const currentFileUploadSelector = createSelector(
  fileUpload,
  ({ file }) => file
);

const isSavedUploadedFileSelector = createSelector(
  fileUpload,
  ({ isSaved }) => isSaved
);

export { currentFileUploadSelector, isSavedUploadedFileSelector };
